export const TYPE_LETTER_ADAPTER = {
	shortage_letter: 'Carta de desabastecimiento',
	faq: 'Políticas y devoluciones',
	electronic_sales_resolution: 'Resolución de venta electrónica',
};
